export const PageHeading = styled.h1`
  font-weight: 800;
  font-size: 26px;
  line-height: 30px;
  color: #171717;
  margin-bottom: 32px;
  margin-top: 50px;
`;

export const SubHeading = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #171717;
  margin-bottom: 32px;
  margin-top: 50px;
`;
